import { Injectable, inject } from "@angular/core";
import { CanActivateFn, Router, UrlTree } from "@angular/router";
import { UserStore } from "../store/user.store";
import { AppRoutes, BUSINESS_UNIT } from "../constants";

@Injectable({ providedIn: "root" })
export class RoleGuard {
  private readonly store = inject(UserStore);
  private readonly router = inject(Router);

  public canActivate: CanActivateFn = (): boolean | UrlTree => {
    const isSuperAdmin = this.store.isSuperAdmin();
    const businessUnit = this.store.currentBusinessUnit();

    const currentPath = window.location.pathname;

    // superadmin has access to everything
    if (isSuperAdmin) {
      return true;
    }

    // business unit specific routes
    if (currentPath.includes(AppRoutes.CHARTERS)) {
      if (businessUnit !== BUSINESS_UNIT.YACHT) {
        return this.router.createUrlTree(["/not-found"]);
      }
    }

    if (currentPath.includes(AppRoutes.VILLA_RESERVATIONS)) {
      if (businessUnit !== BUSINESS_UNIT.VILLA) {
        return this.router.createUrlTree(["/not-found"]);
      }
    }

    // routes that are only accessible by superadmin
    const superAdminOnlyRoutes = [AppRoutes.PACKERS, AppRoutes.CUSTOMERS, AppRoutes.AGENCIES];

    if (superAdminOnlyRoutes.some(route => currentPath.includes(route))) {
      return this.router.createUrlTree(["/not-found"]);
    }

    // all other routes are accessible
    return true;
  };
}
